
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eventos/[slug]",
      function () {
        return require("private-next-pages/eventos/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/eventos/[slug]"])
      });
    }
  